export default {
    newPageCreateFile: "Creazione file in corso",
    globalConfirm: "OK",
    globalCancel: "Annulla",
    globalStyle: "Stile",
    globalColor: "Colore",
    globalLine: "Linea",
};
